import { ca } from '@cian/analytics';

/**
 * Показ блока с планировкой
 */
export function trackElementShown(offerId: number) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show',
    category: 'card',
    label: 'layout_block',
    products: [{ id: offerId }],
  });
}
